import React, { Fragment } from "react"
import Select from "react-select"
import { Button, Col, Label, Row } from "reactstrap"
import { customStylesSelect } from "common/data/settings"

// Define a default UI for filtering
const FilterLayout = props => {
  const {
    selectedMainCategory,
    MainCategory,
    categoryFilter,
    SubCategory,
    selectedSubcategory,
    subcategoryFilter,
    UserList,
    selectedUserData,
    userListFilter,
    buttonname,
    handleCustomerClick,
    companySetting,
    hideTrackProfilebutton,
  } = props


  return (
    <Fragment>
      <Col md="12" className="mt-2 mb-2">
        <Row>
          <Col md="3">
            <div>
              <Label htmlFor="formrow-state-Input">
                {companySetting?.MainCategory}
              </Label>
              <Select
                value ={selectedMainCategory}
                className="mb-2"
                onChange={value => categoryFilter(value)}
                placeholder= {"All"}
                options={
                  MainCategory?.map(el => ({
                    ...el,
                    label: el.name,
                    value: el.name,
                  }))
                }
                styles={customStylesSelect}
                classNamePrefix="select2-selection"
              />
            </div>
          </Col>

          <Col md="3">
            <div>
              <Label htmlFor="formrow-state-Input">
                {companySetting?.SubCategory}
              </Label>
              <Select
                value={selectedSubcategory}
                onChange={value => subcategoryFilter(value)}
                className="mb-2"
                placeholder= {"All"}
                options={SubCategory?.map(el => ({
                  ...el,
                  label: el.name,
                  value: el.name,
                }))}
                classNamePrefix="select2-selection"
                styles={customStylesSelect}
              />

            </div>
          </Col>
          <Col md="3">
            <div>
              <Label htmlFor="formrow-state-Input">User</Label>
              <Select
                // isClearable
                value={selectedUserData}
                className="mb-2"
                onChange={value => userListFilter(value)}
                placeholder= {"All"}
                options={UserList
                  ?.filter(value => value?.userName.trim() !== "")
                  .map(el => ({
                    ...el,
                    label: el.userName,
                    value: el.userId,
                  }))}
                classNamePrefix="select2-selection"
                styles={customStylesSelect}
              />
            </div>
          </Col>
          {hideTrackProfilebutton == true ? (
            <Col md="3">
              <div className="text-sm-end mt-4">
                <Button
                  type="button"
                  color="primary"
                  className="btn-rounded mb-2 me-2"
                  onClick={handleCustomerClick}
                >
                  <i className="mdi mdi-plus me-1" />
                  {buttonname}
                </Button>
              </div>
            </Col>
          ) : (
            ""
          )}
        </Row>
      </Col>
    </Fragment>
  )
}

export default FilterLayout
